import { render } from "./ReviewsPage.vue?vue&type=template&id=5a246e3b&scoped=true"
import script from "./ReviewsPage.vue?vue&type=script&lang=js"
export * from "./ReviewsPage.vue?vue&type=script&lang=js"

import "./ReviewsPage.vue?vue&type=style&index=0&id=5a246e3b&lang=css"
import "./ReviewsPage.vue?vue&type=style&index=1&id=5a246e3b&lang=css"
import "./ReviewsPage.vue?vue&type=style&index=2&id=5a246e3b&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a246e3b"]])

export default __exports__